module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/college-store/university-of-iowa-62e610c6ee22e9c44f2be9dc50ce53ae.jpg";